// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Japan from '../_raw/flag/icon_flag_japan.png';

export default () => <img src={Japan} alt="Japan" />;
